import { useContext, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ReCAPTCHA from "react-google-recaptcha";
import { LanguageContext } from "../../../context/LanguageContext";
import { pop_up_livreur } from "../../../api/auth";

export default function LivreurInfoModal({ open, onClose }) {
  const { t, isRTL } = useContext(LanguageContext);

  const [livreur, setLivreur] = useState({
    first_name: "",
    last_name: "",
    number: "",
    mail: "",
    ville: "",
  });

  const [captchaToken, setCaptchaToken] = useState(null);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLivreur((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaToken) {
      alert(t("pop_up_livreur.captchaError") || "Please verify captcha");
      return;
    }

    try {
      await pop_up_livreur({
        ...livreur,
        captcha: captchaToken, // send to backend
      });

      alert("done");
      onClose();
    } catch (error) {
      alert(t("pop_up_livreur.errorMessage"));
      console.error("Error submitting form:", error);
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4"
      >
        <motion.div
          dir={isRTL ? "rtl" : "ltr"}
          initial={{ scale: 0.9, y: 20 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.9, y: 20 }}
          transition={{ duration: 0.3 }}
          className="w-full max-w-md rounded-2xl bg-white p-8 shadow-xl"
        >
          {/* Header */}
          <div className="mb-6 flex items-center justify-between">
            <h2 className="text-xl font-bold text-gray-900">
              {t("pop_up_livreur.title")}
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              ✕
            </button>
          </div>

          <p className="mb-6 text-sm text-gray-600">
            {t("pop_up_livreur.subtitle")}
          </p>

          {/* Form */}
          <form className="space-y-4" onSubmit={handleSubmit}>
            <input
              name="first_name"
              type="text"
              onChange={handleChange}
              placeholder={t("pop_up_livreur.fields.first_name")}
              className="w-full rounded-xl border px-4 py-3"
              required
            />

            <input
              name="last_name"
              type="text"
              onChange={handleChange}
              placeholder={t("pop_up_livreur.fields.last_name")}
              className="w-full rounded-xl border px-4 py-3"
              required
            />

            <input
              name="mail"
              type="email"
              onChange={handleChange}
              placeholder={t("pop_up_livreur.fields.email")}
              className="w-full rounded-xl border px-4 py-3"
              required
            />

            <input
              name="number"
              type="tel"
              onChange={handleChange}
              placeholder={t("pop_up_livreur.fields.phone")}
              className="w-full rounded-xl border px-4 py-3"
              required
            />

            <input
              name="ville"
              type="text"
              onChange={handleChange}
              placeholder={t("pop_up_livreur.fields.city")}
              className="w-full rounded-xl border px-4 py-3"
              required
            />

            {/* CAPTCHA */}
            <div className="flex justify-center">
              <ReCAPTCHA
                sitekey="6Lc-eVwsAAAAAHTRJLIV8adlg8mffSxEXA0SdyKW"
                onChange={(token) => setCaptchaToken(token)}
              />
            </div>

            <button
              type="submit"
              className="mt-2 w-full rounded-xl bg-indigo-600 py-3 font-semibold text-white hover:bg-indigo-700"
            >
              {t("pop_up_livreur.submit")}
            </button>
          </form>

          <p className="mt-4 text-xs text-gray-400 text-center">
            {t("pop_up_livreur.privacyNote")}
          </p>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
